<template>
    <v-card outlined tile :loading="loading" :disabled="loading">
        <v-card-text class="pa-0">
            <v-expansion-panels flat outlined hover >
                <v-expansion-panel v-for="address in addresses" :key="address.id" >
                    <v-expansion-panel-header>
                        <div>
                            <strong>{{address.address_type.desc + " - "}}</strong>
                            {{address.street}}
                            {{address.city}}
                            {{address.state}}
                            {{address.zipcode}}
                            {{address.zipcodepf}}
                            {{address.county}}
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-divider></v-divider>
                        <DirectoryAddressCard :address="address"></DirectoryAddressCard>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "Addresses",
        components:{
          DirectoryAddressCard: () => import("../../../components/DirectoryAddressCard")
        },
        data: () => ({
            loading: false,
        }),
        props: {
            customer_id:{
                required: true,
            }
        },
        computed:{
            addresses(){
                return this.$store.$db().model('addresses').query().with(['address_type', 'region_type']).where('customer_id', this.customer_id).get()
            }
        },
        mounted(){
            this.loadData();
        },
        methods:{
            async loadData(){
                this.loading = true;
                await this.$store.$db().model('addresses').api().fetch({
                    where: {
                        key: 'customer_id',
                        value: this.customer_id
                    },
                    with: 'addressType,regionType'
                })
                this.loading = false;
            }
        }
    }
</script>

<style scoped>

</style>
